import {
  Box,
  Divider,
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useGetCategoreisOverAppointment } from "../../../../components/form/fileUpload/hooks/useGetCategoreis";
import { useParams } from "react-router-dom";
import { Error } from "@mui/icons-material";
const cellValues = ["OriginalTitle", "NewTitle", "Extension", "Category"];

export default function FilesTable({ files = [] }) {
  const { t } = useTranslation();
  const { id: appointmentId } = useParams();
  const categories = useGetCategoreisOverAppointment(appointmentId);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  if (categories.isLoading) {
    return <LinearProgress />;
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page
  };

  const paginated = files.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  if (files.length == 0) {
    return null;
  }

  function getCategoryName(categoryId) {
    if (categories.error) {
      return <Error />;
    }
    const category = categories?.translatedCategories?.find(
      (val) => Number(val.id) === Number(categoryId),
    );
    if (category == null) {
      return "-";
    }
    return String(category?.title);
  }

  function getFileExtension(path) {
    const split = String(path).split(".");
    const lastIndex = split.length - 1;
    return split[lastIndex];
  }

  return (
    <Box mb={3}>
      <Paper elevation={2} sx={{ padding: 3, borderRadius: 2 }}>
        <Typography variant="h6" gutterBottom fontWeight={"light"}>
          {t("Files")}
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <TableContainer sx={{ minHeight: 400, overflowY: "auto" }}>
          <Table sx={{ minWidth: 650 }} aria-label="vaccination table">
            <TableHead>
              <TableRow>
                {cellValues?.map((val) => (
                  <TableCell>{t(val)}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {paginated.map((item, index) => {
                if (item?.value !== "NoInfo") {
                  return (
                    <TableRow key={index}>
                      <TableCell>{item?.path}</TableCell>
                      <TableCell>{item?.title ?? item?.path}</TableCell>
                      <TableCell>{getFileExtension(item?.path)}</TableCell>
                      <TableCell>{getCategoryName(item?.category)}</TableCell>
                    </TableRow>
                  );
                }
                return null;
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5]}
          component="div"
          labelRowsPerPage={t("RowsPerPage")}
          count={files.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          backIconButtonProps={{
            title: t("PreviousPage"),
            "aria-label": t("PreviousPage"),
          }}
          nextIconButtonProps={{
            title: t("NextPage"),
            "aria-label": t("NextPage"),
          }}
        />
      </Paper>
    </Box>
  );
}
